module.exports = __webpack_public_path__ + "static/img/9.fa9c85c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/9.png
// module id = X61e
// module chunks = 0